var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"mt-3 mb-16"},[_c('tabela-sindicato-evento')],1),_vm._v(" "),_c('div',{staticClass:"mt-5 mb-3 mt-16"},[_c('tabela-participante-evento')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h2',[_vm._v("Lista de Participantes")])])
}]

export { render, staticRenderFns }